import { CfFilterListProps } from "../types";
import FilterList from "..";
import React from "react";

const CfFilterList = (props: CfFilterListProps) => <FilterList {...props} />;

export default CfFilterList;
